export const BANK_CHOICES = [
  { id: "BANCOLOMBIA", name: "Bancolombia" },
  { id: "BANCO_BOGOTA", name: "Banco de Bogotá" },
  { id: "DAVIVIENDA", name: "Davivienda" },
  { id: "BBVA", name: "BBVA Colombia" },
  { id: "OCCIDENTE", name: "Banco de Occidente" },
  { id: "POPULAR", name: "Banco Popular" },
  { id: "AVVILLAS", name: "Banco AV Villas" },
  { id: "CAJA_SOCIAL", name: "Banco Caja Social" },
  { id: "ITAU", name: "Itaú" },
  { id: "SCOTIABANK", name: "Scotiabank Colpatria" },
  { id: "FALABELLA", name: "Banco Falabella" },
  { id: "BANCAMIA", name: "Bancamía" },
  { id: "BANCOW", name: "Banco W" },
  { id: "COOPCENTRAL", name: "Banco Coopcentral" },
  { id: "FINANDINA", name: "Banco Finandina" },
  { id: "NEQUI", name: "Nequi" },
  { id: "DAVIPLATA", name: "Daviplata" },
  { id: "MOVII", name: "Movii" },
  { id: "LULO", name: "Lulo Bank" },
  { id: "NU_BANK", name: "Nu Bank" },
];

const WALLET_BANK_IDS = new Set([
  "NEQUI",
  "DAVIPLATA",
  "MOVII",
  "NU_BANK",
  "LULO",
]);

export function isWalletBank(bankId) {
  return WALLET_BANK_IDS.has(bankId);
}

export function bankNameFromId(bankId) {
  return BANK_CHOICES.find((b) => b.id === bankId)?.name || bankId;
}
